import script from "./CrucesEjercitos.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrucesEjercitos.vue?vue&type=script&setup=true&lang=ts"

import "./CrucesEjercitos.vue?vue&type=style&index=0&id=370a79d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370a79d3"]])

export default __exports__